import BaseObject from '../../../../../../base/base_object';
import _ from '../../../../../../utils/underscore'; // eslint-disable-line id-length
import {AF} from './app_flayer_const';
import Device from '../../../../../../utils/device';
import {KEY_NAME} from '../../../../native/native_const';


/**
 *
 */
class AppFlayerModel extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'AppFlayerModel';


    /**
     * @property
     * @type {string}
     * @private
     */
    _afID = '';
    _appName = '';
    _deviceID = '';
    _afinstall = '';
    _serialData = '';
    _serialDataDecode = '';


    /**
     * Merge Marketing Data with hybrid params
     *
     * @param json: the original json
     * @returns {merged json}
     * @private
     */
    _mergeMarketingData(json) {
        let output = Object.assign({}, json, this._getCommonData());
            return output;
    }

     _getCommonData() {
        let output = {
            [AF.ID]: this._afID,
            [AF.APP_NAME]: this._appName,
            [AF.DEVICE_ID]: this._deviceID,
            [AF.AF_INSTALL]: this._afinstall
        };

        return output;
    }

    /**
     * fill the data from hybrid
     *
     * @param json
     * @private
     */
    _fillGeneralData(orgData) {

        let json = _.safeJSONandDecode(orgData)

        let error = json[KEY_NAME.ERROR];
        if (error !== 0) {
            return;
        }
        let data = json[KEY_NAME.DATA];


        this._appName = Device.isNativeIOS() ? 'id' + data[AF.APP_NAME] : data[AF.APP_NAME];
        this._afID = data[AF.ID];
        this._deviceID = data[AF.DEVICE_ID];
        this._serialData = data[AF.SERIAL_DATA];
        this._afinstall = decodeURIComponent(this._serialData);
        this._serialDataDecode = _.safeJSONandDecode(this._serialData);
    }

    /**
     * Get the Marketing Data to return
     *
     * @param marketingData: the original json from the site
     * @returns {retVal merged with/without hybrid response}
     * @private
     */
    _getMarketingData(marketingData) {
        return this._mergeMarketingData(marketingData);
    }


    /**
     * Update the marketingData with the appsflayer data
     *
     * @param marketingData: the original json from the site
     * @param data: the data from the hybrid appsflayer
     * @returns {marketingData merged with the hybrid response}
     */
    updateData(marketingData, data) {
        this._fillGeneralData(data);
        return this._getMarketingData(marketingData);
    }

    _getData(key, val){
        return '"' + key + '" :' + val;
    }

    getSmartLinkData() {

        let strAFInstall = this._getData(AF.AFInstall , this._afinstall);
        let strAppsFlyerID = this._getData(AF.AppsFlyerID ,'"' + this._afID + '"');

        let data = '{' + strAFInstall + ',' + strAppsFlyerID + '}';

        return data;
    }
}

export default AppFlayerModel;